export default function getResource(label) {
    const resources = {
        // Variant 1: Trial eligible, NOT in basket
        variant1Message: 'Start saving with a FREE 30-Day trial of Sephora Same-Day Unlimited',
        variant1Cta: 'Try for Free',

        // Variant 2: NOT trial eligible, NOT in basket
        variant2Message: 'Start saving with Sephora Same-Day Unlimited',
        variant2Cta: 'Sign Up',

        // Variant 3: Trial eligible, IN basket
        variant3Message: 'Your basket contains a FREE 30-day trial of Same-Day Unlimited',
        variant3Cta: 'Learn More',

        // Variant 4: NOT trial eligible, IN basket
        variant4Message: 'Your basket contains a Same-Day Unlimited subscription',
        variant4Cta: 'Learn More'
    };

    return resources[label];
}
